// import Layout from '@/layouts'

// const schedule = {
//   path: '/bunk',
//   component: Layout,
//   name: 'bunk',
//   redirect: '/bunk/index',
//   children: [{
//     path: '/bunk/index',
//     component: () => import('@/views/bunk/index'),
//     name: 'bunk.index',
//     meta: {
//       title: 'График'
//     }
//   }, ]
// }

// export default schedule
import Layout from "@/layouts"
import {i18n} from "@/utils/i18n";

const schedule = {
  path: "/bunk",
  component: Layout,
  name: "bunkParent",
  redirect: "/bunk/main",
  children: [
    {
      path: "/bunk",
      component: () => import("@/views/bunk/index"),
      name: "bunk.index",
      meta: {
        title: "",
      },
      redirect: "/bunk/main",
      children: [
        {
          path: "/bunk/main",
          component: () => import("@/views/bunk/housing"),
          name: "housing",
          meta: {
            title: i18n.t(`message.housing`),
          },
        },
        {
          path: "/bunk/floor",
          component: () => import("@/views/bunk/floor"),
          name: "floor",
          meta: {
            title: i18n.t(`message.floors`),
          },
        },
        {
          path: "/bunk/class",
          component: () => import("@/views/bunk/class"),
          name: "class",
          meta: {
            title: i18n.t(`message.classes`),
          },
        },
        {
          path: "/bunk/hospitalRooms",
          component: () => import("@/views/bunk/hospitalRooms"),
          name: "hospitalRooms",
          meta: {
            title: i18n.t(`message.rooms`),
          },
        },
        {
          path: "/bunk/patientHistoryTypes",
          component: () => import("@/views/bunk/patientHistoryType"),
          name: "patientHistoryType",
          meta: {
            title: i18n.t(`message.patient_history_types`),
          },
        },
        // {
        //   path: '/bunk/hospitalRooms/withbunk',
        //   component: () => import('@/views/schedulesCabinet/index'),
        //   name: 'schedulesCabinet',
        //   meta: {
        //     title: ''
        //   }
        // },
        {
          path: "/bunk/bunk",
          component: () => import("@/views/bunk/bunk"),
          name: "bunk",
          meta: {
            title: "Койки",
          },
        },
        {
          path: "/bunk/departments",
          component: () => import("@/views/bunk/departments"),
          name: "departments",
          meta: {
            title: i18n.t(`message.branches`),
          },
        },
        {
          path: "/bunk/departmentUser",
          component: () => import("@/views/bunk/departmentUser"),
          name: "departmentUser",
          meta: {
            title: i18n.t(`message.department_users`),
          },
        },
        {
          path: "/bunk/hospitalizationType",
          component: () => import("@/views/bunk/hospitalizationType"),
          name: "hospitalizationType",
          meta: {
            title: i18n.t(`message.hospitalization_types`),
          },
        },
        {
          path: "/bunk/purposHospitalization",
          component: () => import("@/views/bunk/purposHospitalization"),
          name: "purposHospitalization",
          meta: {
            title: i18n.t(`message.purposes_of_hospitalization`),
          },
        },
        {
          path: "/bunk/typeInjury",
          component: () => import("@/views/bunk/typeInjury"),
          name: "typeInjury",
          meta: {
            title: "Виды травм",
          },
        },
        {
          path: "/bunk/injuryStatus",
          component: () => import("@/views/bunk/injuryStatus"),
          name: "injuryStatus",
          meta: {
            title: i18n.t(`message.injury_statuses`),
          },
        },
        {
          path: "/bunk/patentIndicator",
          component: () => import("@/views/bunk/patentIndicator"),
          name: "patentIndicator",
          meta: {
            title: i18n.t(`message.patient_indicators`),
          },
        },
        {
          path: "/bunk/pockets",
          component: () => import("@/views/bunk/pockets"),
          name: "pockets",
          meta: {
            title: i18n.t(`message.pockets`),
          },
        },
      ],
    },
  ],
}

export default schedule
